// extracted by mini-css-extract-plugin
export default {"demo_left_section":"RequestDemoLeftSection_demo_left_section__M9cMZ"};